module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_library.js
// module id = ../../../node_modules/core-js/modules/_library.js
// module chunks = 0